import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Toast, ToastBody, ToastHeader, Table, Row, Col, Input, Label } from 'reactstrap';
import {
         Afr, getSelectedAfr, Audit, getRow, getFact,
    getSelectedAffiliateReport, isCRAAuditRequired,
    FactTable, AffiliateReporting, updateAffiliateReport, updateAffiliateReportingType, isCRA, getMergedAEs, factValue
} from '../../redux/AfrSlice';
import { resetAuditorState } from '../../redux/AuditorSlice';
import "react-widgets/styles.css";   
import 'react-dropdown-tree-select/dist/styles.css'
import { setIsDirty, updateAffiliateAuditors, AffiliateAuditor, getTableFacts, updateAffiliate} from '../../redux/MiscSlice';
import enums from '../../utils/enums';
import { Alert } from 'reactstrap';
import AuditEditor from '../feature/AuditEditor';
import utilityHelper from '../../utils/utilityHelper';
import { AFRError } from '../../redux/ValidationSlice';
import { getSelectedAffiliateEntityCode } from '../../redux/AffiliateSlice';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';


const AffiliatedEntitiesAuditDetail = () => {
    //TODO create a generic reporter component to actually render the topic and details.
    //props should include title and detail list
    const dispatch = useAppDispatch();

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const affiliateCode = useAppSelector(getSelectedAffiliateEntityCode);
    const mergedAffiliates: Array<AffiliateReporting> | null = useAppSelector(getMergedAEs);
    const miscTableFacts: Array<factValue> | null = useAppSelector(getTableFacts);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);


    const [currentAffiliatedEntity, setCurrentAffiliatedEntity] = React.useState<AffiliateReporting | null>(utilityHelper.getSelectedAffiliateReport(mergedAffiliates ? mergedAffiliates : [], affiliateCode));

    const [hasAudit, setHasAudit] = useState((currentAffiliatedEntity && currentAffiliatedEntity.audit) ? true : false);
    const [audit, setAudit] = useState((currentAffiliatedEntity && currentAffiliatedEntity.audit) ? "AUDIT" : "NO_AUDIT");
    const [auditRequired, setAuditRequired] = useState(false);
    

    const affiliateName: string = (currentAffiliatedEntity && currentAffiliatedEntity.affiliateReference ? currentAffiliatedEntity.affiliateReference.name : "");

    var style = "auditDetail";
    var title = "Audit Information for " + affiliateName;


    const showAuditInformation = function () {

        return isCRA(currentAffiliatedEntity);
    }
    const getAffiliateId = function (affiliatedEntity: AffiliateReporting | null): string
    {
        if (!affiliatedEntity || !affiliatedEntity.affiliateReference ) {
            return "";
        }
        return affiliatedEntity.affiliateReference.code;
    }
    const handleSaveAudit = function (audit: Audit) {
        if (!currentAfr) {
            return;
        }
        var updatedAffiliatedEntity: AffiliateReporting = JSON.parse(JSON.stringify(currentAffiliatedEntity));
        updatedAffiliatedEntity.audit = { ...audit };
        updatedAffiliatedEntity.audit.auditType = "AUDIT";

        // Update in redux
        dispatch(updateAffiliate(updatedAffiliatedEntity));

        // Update the new auditor on misc slice to let the grid know that the data was changed
        var updAuditor: AffiliateAuditor = {
            affiliateEntityCode: affiliateCode,
            affiliateName: affiliateName,
            auditor: (audit.auditorReference ? audit.auditorReference.code :"" )
        }

        dispatch(updateAffiliateAuditors(updAuditor));

        /* Check and notify any error */
        var errorMessage: Array<AFRError> = [];
        utilityHelper.isAffiliatedEntitySatisfied(currentAfr, errorMessage, dispatch);
        utilityHelper.notifyErrors(currentAfr, enums.UISection.affiliatedEntities, errorMessage, dispatch);
    }

    const handleChange = function (event : any) {
        if (!currentAffiliatedEntity) {
            return;
        }
        var value: string = event.target.value
        var audit: Audit | null = null;
        setAudit(event.target.value);


        if (value === "NO_AUDIT") {
            // reset the audit object and the uploaded date
            var updatedAffiliatedEntity: AffiliateReporting =
            {
                affiliateReference: currentAffiliatedEntity.affiliateReference,
                reportingType: currentAffiliatedEntity.reportingType,
                auditReceivedDate: null,
                affiliateReportingForAfr: null,
                independentTotals: null,
                audit: null,
            };


            // Turn ON the dirty flag in redux
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
        } else {
             audit = {
                auditorReference: null,
                auditPdf: null,
                auditType: "AUDIT",
                datePerformed: null,
                sendAuditPdf: null,
                dateReceived: null,
             }

            // reset the audit object and the uploaded date
            var updatedAffiliatedEntity: AffiliateReporting =
            {
                affiliateReference: currentAffiliatedEntity.affiliateReference,
                reportingType: currentAffiliatedEntity.reportingType,
                auditReceivedDate: null,
                affiliateReportingForAfr: null,
                independentTotals: null,
                audit: audit,
            };

        }
        // Update in redux
        dispatch(resetAuditorState({}));

        dispatch(updateAffiliate(updatedAffiliatedEntity));

        // Update the new auditor on misc slice to allow the grid to know
        var updAuditor: AffiliateAuditor = {
            affiliateEntityCode: affiliateCode,
            affiliateName: affiliateName,
            auditor: ""
        }
        dispatch(updateAffiliateAuditors(updAuditor));

        // Turn ON the dirty flag in redux
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

        setHasAudit((value === "AUDIT") && (currentAffiliatedEntity && currentAffiliatedEntity.audit ? true : false));

    }


    useEffect(() => {

        setHasAudit((currentAffiliatedEntity && currentAffiliatedEntity.audit) ? true : false);
        setAudit((currentAffiliatedEntity && currentAffiliatedEntity.audit) ? "AUDIT" : "NO_AUDIT");

    }, [currentAffiliatedEntity]);

    useEffect(() => {
        if (currentAfr) {
            const mergedFacts = utilityHelper.getMergedFacts(enums.tableName.affiliatedEntity, currentAfr, miscTableFacts ? miscTableFacts : [] );

            setAuditRequired(utilityHelper.isCRAAuditRequired(mergedAffiliates ? mergedAffiliates : [], mergedFacts, affiliateCode));
        }

    }, [miscTableFacts, mergedAffiliates ])


    useEffect(() => {

        /* Check and notify any error */
        if (currentAfr) {

            var errorMessage: Array<AFRError> = [];
            utilityHelper.isAffiliatedEntitySatisfied(currentAfr, errorMessage, dispatch);
            utilityHelper.notifyErrors(currentAfr, enums.UISection.affiliatedEntities, errorMessage, dispatch);
        }
    }, [miscTableFacts, mergedAffiliates])

    React.useEffect(() => {
        setCurrentAffiliatedEntity(utilityHelper.getSelectedAffiliateReport(mergedAffiliates ? mergedAffiliates : [], affiliateCode));

    }, [mergedAffiliates, affiliateCode])

    return (
        <div>
            { showAuditInformation() ?
                (<Toast className={style}>
                    <ToastHeader className={style}>{title}</ToastHeader>
                    <ToastBody className={style}>
                        <Row>
                            <Col>
                                <h6>Community Redevelopment Agencies</h6>
                                <p>Per 218.32(3)(b), Community Redevelopment Agencies that meet a revenue or expenditure balance threshold are required to submit an independently audited financial statement to their primary government. Also, the primary government must provide a copy of their Community Redevelopment Agencies’ audited financial statement with their AFR. If an audit is completed, you will be prompted to supply firm and completion information. Copies of any uploaded audits will be available on the Documents Tab on the AFR Summary Screen.</p>
                                {(auditRequired===true) &&
                                    (<Alert color="danger">
                                       <p>This CRA should be submitted with an audited Financial Statement. To verify the financial data submitted, an audited financial statement must accompany the AFR. Please refer all questions concerning this requirement to the Bureau of Financial Reporting, Local Government Section at (850)413-5571 or localgov@myfloridacfo.com</p>
                                     </Alert>)}
                            </Col>
                        </Row>
                        <Row>

                            <Col md="2">
                                <Table bordered>
                                    <thead>
                                        <tr>
                                            <th className="card-header" style={{
                                                color: "white",
                                                backgroundColor: "#458BCA",
                                                borderRadius: "0px",
                                                fontWeight: "initial"
                                            }}>Was an audit performed?
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan={2}>
                                                <Label className="ml-4" check>
                                                    <Input type="radio"
                                                        name="radioAudit"
                                                        value={"AUDIT"}
                                                        disabled={utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
                                                            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                        onChange={handleChange}
                                                        checked={(audit === "AUDIT")}
                                                    /><b>Yes</b>
                                                </Label>
                                                <Label className="ml-5" check>
                                                    <Input type="radio"
                                                        value={"NO_AUDIT"}
                                                        name="radioAudit"
                                                        onChange={handleChange}
                                                        checked={(audit === "NO_AUDIT")}
                                                        disabled={auditRequired === true || utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
                                                            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                    /><b>No</b>
                                                </Label>

                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                            <Col md="10">
                                <AuditEditor
                                    containerParentOfAudit={currentAffiliatedEntity}
                                    containerType={enums.auditSource.affiliatedEntity + "^" + getAffiliateId(currentAffiliatedEntity)}
                                    saveAudit={handleSaveAudit} />
                            </Col>

                        </Row>


                    </ToastBody>
                </Toast>)
                : (<div></div>)
            }
        </div>
    )

}

export default AffiliatedEntitiesAuditDetail;